const DIMENSIONS_PATTERN =
  /^\d+(?:[.,]\d+)?\s*[x*]\s*\d+(?:[.,]\d+)?\s*[x*]\s*\d+(?:[.,]\d+)?(?:\s*cm)?$/i

export const isShoeCategory = (id: unknown): boolean => {
  const value = String(id ?? '')
  return value.startsWith('14') || ['130106', '130306', '130405'].includes(value)
}

export const isValidProductDimensions = (value: unknown): boolean =>
  DIMENSIONS_PATTERN.test(String(value ?? '').trim())
